import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { useSiteSettings } from "@/data/useSiteSettings";
import {
  CTA_BANNER_DARK_DEFAULT,
  CTA_BANNER_LIGHT_DEFAULT,
  mergeSection,
} from "@/data/homepageSectionDefaults";

export default function CTABanner({ variant = "light" }) {
  const settings = useSiteSettings();

  if (variant === "dark") {
    const c = mergeSection(
      CTA_BANNER_DARK_DEFAULT,
      settings?.homepage?.cta_banner_dark,
    );
    return (
      <section data-testid="cta-banner-dark" className="bg-sky-600 py-9 lg:py-12 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-[20%] w-64 h-64 bg-sky-400/20 rounded-full blur-[80px]" />
          <div className="absolute bottom-0 right-[15%] w-48 h-48 bg-white/5 rounded-full blur-[60px]" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-5 relative">
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-white">
              {c.heading}
            </h3>
            <p className="mt-1 text-sm text-sky-100">
              {c.intro}
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Link to={c.primary_cta_href}>
              <Button
                data-testid="cta-banner-demo-btn"
                className="btn-premium bg-white text-sky-700 hover:bg-sky-50 rounded-full px-6 h-11 text-sm font-semibold shadow-lg shadow-sky-900/15"
              >
                {c.primary_cta_label} <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to={c.secondary_cta_href}>
              <Button
                variant="outline"
                data-testid="cta-banner-contact-btn"
                className="btn-premium border-white/40 text-white hover:bg-sky-700 rounded-full px-6 h-11 text-sm font-semibold"
              >
                <Phone className="mr-2 h-4 w-4" /> {c.secondary_cta_label}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const c = mergeSection(
    CTA_BANNER_LIGHT_DEFAULT,
    settings?.homepage?.cta_banner_light,
  );
  return (
    <section data-testid="cta-banner-light" className="bg-slate-50 border-y border-slate-100 py-9 lg:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-5">
        <div>
          <h3 className="text-xl sm:text-2xl font-bold text-slate-900">
            {c.heading}
          </h3>
          <p className="mt-1 text-sm text-slate-500">
            {c.intro}
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Link to={c.cta_href}>
            <Button
              data-testid="cta-banner-schedule-btn"
              className="btn-premium bg-sky-600 hover:bg-sky-700 text-white rounded-full px-6 h-11 text-sm font-semibold shadow-lg shadow-sky-600/25"
            >
              {c.cta_label} <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
